module.exports = __webpack_public_path__ + "img/karolinainsta.46e0d34a.jpg";